export default [
  {
    id: 'department',
    text: 'Departamento',
    title: 'Nome do departamento do usuário / ramal',
    checked: true
  },
  {
    id: 'userName',
    text: 'Usuário/ atendedor',
    title: 'Nome do usuário',
    checked: true
  },
  {
    id: 'extension',
    text: 'Ramal',
    title: 'Número ramal do usuário',
    checked: true
  },
  {
    id: 'total',
    text: 'Total',
    title: 'Chamadas que o usuário fez parte (recebidas e executadas)',
    checked: false
  },
  {
    id: 'outgoing',
    text: 'Saintes',
    title: 'Chamadas que fez para destinos externos (clientes, etc...)',
    checked: true
  },
  {
    id: 'made',
    text: 'Executadas',
    title: 'Chamadas feitas pelo usuário (internas, saintes)',
    checked: true
  },
  {
    id: 'internal',
    text: 'Internas',
    title: 'Internas que o usuário fez parte (recebidas e executadas)',
    checked: false
  },
  {
    id: 'internalOut',
    text: 'Internas feitas',
    title: 'Internas executadas (ramal-ramal / ramal-grupo)',
    checked: false
  },
  {
    id: 'internalIn',
    text: 'Internas recebidas',
    title: 'Internas recebidas (ramal-ramal / ramal-grupo)',
    checked: false
  },
  {
    id: 'received',
    text: 'Recebidas',
    title: 'Recebidas pelo ramal / usuário (internas e externas)',
    checked: true
  },
  {
    id: 'incoming',
    text: 'Entrada',
    title: 'Recebidas de origem externa',
    checked: true
  },
  {
    id: 'ttring',
    text: 'T. ring(P)',
    title: 'Tempo total de espera em ring',
    checked: false
  },
  {
    id: 'avgring',
    text: 'TM. ring(P)',
    title: 'Tempo médio de espera em ring',
    checked: false
  },
  {
    id: 'minring',
    text: 'Min. ring(P)',
    title: 'Menor tempo de espera em ring',
    checked: false
  },
  {
    id: 'maxring',
    text: 'Max. ring(P)',
    title: 'Maior tempo de espera em ring',
    checked: false
  },
  {
    id: 'answered',
    text: 'Atendidas',
    title: 'Atendidas de quais quer origem (internas e externas)',
    checked: true
  },
  {
    id: 'transferred',
    text: 'Transferidas',
    title:
      ' Ligações que foram transferidas por este operador, grupo, departamento, etc. Para outro destino',
    checked: true
  },
  {
    id: 'answeredIn',
    text: 'Externas atendidas',
    title: 'Atendidas de origem externas',
    checked: false
  },
  {
    id: 'pctAnswered',
    text: '% atendidas',
    title:
      ' Percentual de chamadas atendidas de quais quer origem (internas e externas)',
    checked: false
  },
  {
    id: 'ttanswer',
    text: 'T. atendimento(P)',
    title: 'Tempo total de atendimento do usuario no ramal',
    checked: false
  },
  {
    id: 'avganswer',
    text: 'TM. atendimento(P)',
    title: 'Tempo médio de atendimento do usuário no ramal',
    checked: false
  },
  {
    id: 'minanswer',
    text: 'Mix. atendimento(P)',
    title: 'Menor tempo de atendimento do usuário no ramal',
    checked: false
  },
  {
    id: 'maxanswer',
    text: 'Max. atendimento(P)',
    title: 'Maior tempo de atendimento do usuario no ramal',
    checked: false
  },
  {
    id: 'notAnswered',
    text: 'Não atendidas',
    title: 'Não atendidas',
    checked: false
  },
  {
    id: 'pctNotAnswered',
    text: '% não atendidas',
    title: 'Percentual de chamadas não atendidas',
    checked: true
  },
  {
    id: 'callPickup',
    text: 'Capturadas',
    title: 'Atendimentos a partir de captura',
    checked: true
  },
  {
    id: 'scores',
    text: 'Chamadas avaliadas',
    title: 'Quantidade de chamadas avalidas pelos clientes',
    checked: false
  },
  {
    id: 'score',
    text: 'Nota total',
    title: 'Soma das notas de chamadas avalidas pelos clientes',
    checked: false
  },
  {
    id: 'avgscore',
    text: 'Nota média',
    title: 'Média das notas recebidas',
    checked: false
  },
  {
    id: 'minscore',
    text: 'Menor Nota',
    title: 'Menor nota recebida',
    checked: false
  },
  {
    id: 'maxscore',
    text: 'Maior Nota',
    title: 'Maior nota recebida',
    checked: false
  }
];
